<div class="flex flex-col gap-4">
    <div id="loinc-search" class="main__search flex justify-between mb-2 relative">
        <div class="flex max-lg:flex-col max-lg:space-y-4 items-center lg:space-x-4">
            <div #boxSearch class=" bar-1 bg-white flex items-center relative">
                <div class="w-[50px] h-full flex items-center justify-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        class="translate-x-[2px]"
                        height="24"
                        fill="#5F6368"
                    >
                        <path
                            d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                        />
                    </svg>
                </div>
                <input
                    #searchInput
                    [formControl]="query"
                    (keyup.enter)="search()"
                    id="search"
                    class="searchbar"
                    autocomplete="off"
                    placeholder="{{
                        language === 'en' ? 'Enter keywords to search' : 'Nhập từ khóa để tìm kiếm...'
                    }}"
                    type="text"
                    title="Search"
                />
                <div
                    (click)="emptySearchBox()"
                    [ngClass]="{ hidden: query.value.length <= 0, flex: query.value.length > 0 }"
                    class="w-[50px] h-6 items-center justify-center cursor-pointer z-[1001]"
                >
                    <svg
                        focusable="false"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        *ngIf="!loadingState.searching"
                    >
                        <path
                            fill="#70757a"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                        ></path>
                    </svg>
                    <div class="spinner-container">
                        <div class="spinner" *ngIf="loadingState.searching"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-[45px] flex space-x-4">
            <div *ngIf="loadingState.sorting" class="spinner-container pt-[12px]">
                <div class="spinner"></div>
            </div>
            <mat-form-field appearance="outline" class="h-full">
                <mat-label>
                    {{ language == 'en' ? 'Sort by' : 'Sắp xếp theo' }}
                </mat-label>
                <mat-select [formControl]="ordering" (selectionChange)="sort()">
                    <mat-option *ngFor="let field of get_keys() | keyvalue : originalOrder" [value]="field.key">
                        {{ field.value }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-checkbox class="h-full pt-[10px]" [labelPosition]="'before'" [formControl]="reverse" (change)="sort()">
                {{ language == 'en' ? 'Reverse' : 'Giảm dần' }}
            </mat-checkbox>
        </div>
    </div>
    <span *ngIf="isResultEmpty()" class="text-center text-gray-500">
        {{language === 'vi' ? 'Không tìm thấy kết quả nào!' : 'No results found.'}}
    </span>
    <table *ngIf="!isResultEmpty()" cTable>
        <thead>
        <tr>
            <th scope="col" *ngFor="let field of get_keys() | keyvalue : originalOrder">{{ field.value }}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let result of results" class="hover:bg-gray-300">
            <td *ngFor="let field of get_keys() | keyvalue : originalOrder">
                <a [routerLink]="result['id']['value']" *ngIf="field.key === primaryKey">{{ result[field.key]['value'] }}</a>
                <div
                    *ngIf="field.key !== primaryKey"
                    [class]="field.key === 'long_common_name' || field.key === 'component' ? 'text-left' : 'text-center'"
                    class="w-full"
                >
                    {{ result[field.key]['value'] }}
                </div>
            </td>
        </tr>
        </tbody>
    </table>
    <div *ngIf="!isResultEmpty()" class="flex justify-end space-x-4">
        <div *ngIf="loadingState.paginating" class="spinner-container pt-[18px]">
            <div class="spinner"></div>
        </div>
        <mat-paginator class="paginator"
                       [length]="totalPages"
                       [pageSize]="itemsPerPage"
                       [pageSizeOptions]="[10, 25, 50, 100]"
                       [pageIndex]="pageIndex"
                       (page)="paginate($event)">
        </mat-paginator>
    </div>
</div>
